module.exports = __webpack_public_path__ + "assets/img/Type E (79).80fbf8ec.jpg";